import { Component } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldBaseComponent } from '@shared/components/forms/components/field-base';

@Component({
  selector: 'lib-form-button',
  styleUrls: ['form-button.component.scss'],
  templateUrl: 'form-button.component.html',
  imports: [FormsModule, ReactiveFormsModule],
})
export class FormButtonComponent extends FieldBaseComponent {}
